import type {TableConfiguration} from 'schema/table/types';
import type {NorafUpdate} from 'services/agent/types';
import {defaultTableConfig} from 'schema/table/configuration/defaultTableConfig';
import {AgentTypeRenderer, DateTime} from '../../renderers/table';

export const norafUpdateTableConfig: TableConfiguration<NorafUpdate> = {
  ...defaultTableConfig,
  disableSorting: true,
  enableSelectionButton: 'multiple',
  partValueRenderers: {
    agentType: AgentTypeRenderer,
    lastUpdated: DateTime,
  },
};
